import type { Metric } from 'web-vitals'

import { safeDataLayer } from '@modules/utils/gtm'

/**
 * Web Vitals のデータを Google Tag Manager に送信
 * @param metric Web Vitals の測定データ
 */
export const sendToGTM = (metric: Metric) => {
  safeDataLayer({
    event: 'web-vitals',
    webVitalCategory: metric.name, // "LCP", "FID", "CLS" など
    webVitalValue: metric.value, // 秒単位 (ms ではない)
    webVitalDelta: metric.delta, // 直前の計測との差分
    webVitalId: metric.id, // 一意の識別子
  })
}
